export class QuoteCoverageCue {
  hasIdFraud = "N";
  hasPetDamage = "N";
  hasWaterBackup = "N";
  hasWaterDamageLiability = "N";
  hasReplacementCost = "N";
  hasEarthquake = "N";
  hasInternetCredit = "N";
  hasLossFreeCredit = "N";
  hasConstructionType = "N";
  hasHurricaneDeductible = "N";
  personalLiabilityOptions = [];
  deductibleOptions = [];
  personalPropertyMin = 0;
  personalPropertyMax = 0;
  personalPropertyIncrement = 0;
}
